import { Modal, ModalProps, Typography } from 'antd';

interface ConfirmRequestJobPostingRejectModalProps extends ModalProps {
  requestJobPostingName: string;
}

const ConfirmRequestJobPostingRejectModal = ({
  requestJobPostingName,
  ...props
}: ConfirmRequestJobPostingRejectModalProps) => {
  return (
    <Modal
      title={
        <Typography.Text>
          Reprovar requisição <Typography.Text strong>{requestJobPostingName}</Typography.Text>
        </Typography.Text>
      }
      okText="OK"
      cancelText="Cancelar"
      {...props}
    >
      <Typography.Paragraph>
        Ao reprovar a requisição <Typography.Text strong>{requestJobPostingName}</Typography.Text>,
        ela será finalizada de forma permanente e não poderá ser retomada. Deseja continuar?
      </Typography.Paragraph>
    </Modal>
  );
};

export default ConfirmRequestJobPostingRejectModal;
